<template>
    <div id="login">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2>Nover</h2>
                    <p>Đăng nhập để thêm dịch vụ miễn phí:</p>
                    <p>- Bình luận truyện.</p>
                    <p>- Đồng bộ Truyện mới đọc và Yêu thích (Bạn có thể đọc truyện trên nhiều thiết bị khác nhau).</p>
                    <p>- Đồng bộ dữ liệu giữa web và thiết bị di động.</p>
                    <div class="button-container">
                        <g-signin-button
                            :params="googleSignInParams"
                            @success="onSignInSuccess"
                            @error="onSignInError">
                            Sign in with Google
                        </g-signin-button>
                        <fb-signin-button
                            :params="fbSignInParams"
                            @success="onSignInSuccessFB"
                            @error="onSignInErrorFB">
                            Sign in with Facebook
                        </fb-signin-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP } from "../common/http-common";
import { bus } from '../main'

    export default {
        data() {
            return {
                googleSignInParams: {
                    client_id: '1017447265279-7ch4rgqgr3jme25c6gl23jhfgnekrhvq.apps.googleusercontent.com'
                },
                fbSignInParams: {
                    scope: 'email, public_profile',
                    return_scopes: true
                }
            }
        },
        methods: {
            onSignInSuccess (googleUser) {
                // `googleUser` is the GoogleUser object that represents the just-signed-in user.
                // See https://developers.google.com/identity/sign-in/web/reference#users
                let gProfile = googleUser.getBasicProfile()
                let providerToken = googleUser.getAuthResponse().id_token

                let profile = { 
                    providerKey: 'google_token', 
                    providerToken: providerToken,
                    name: gProfile.getName(), 
                    email: gProfile.getEmail(), 
                    image: gProfile.getImageUrl()
                }

                this.signInToServer(profile)
            },
            onSignInError (error) {
                // `error` contains any error occurred.
                console.log('OH NOES', error)
            },
            onSignInSuccessFB (response) {
                let providerToken = response.authResponse.accessToken
                window.FB.api('/me', { fields: 'name, email' }, dude => {
                    let avatar = `http://graph.facebook.com/${dude.id}/picture?type=large`
                    let profile = { providerKey: 'fb_token', providerToken: providerToken, name: dude.name, email: dude.email, image: avatar}
                    this.signInToServer(profile)
                })
            },
            onSignInErrorFB (error) {
                console.log('OH NOES', error)
            },
            signInToServer(profile) {
                let providerKey = profile.providerKey || ''
                let providerToken = profile.providerToken
                let currentToken = localStorage.accessToken || ''

                let path = "login/"
                HTTP.post(path, {
                    'name': profile.name,
                    'email': profile.email,
                    'image': profile.image,
                    [providerKey]: providerToken,
                    'access_token': currentToken,
                    'device_id': ''
                })
                .then(response => {
                    let data = response.data
                    localStorage.accessToken = data.access_token
                    localStorage.userId = data.id
                    this.sendLoggedInEvent()
                    this.$router.push({ path: this.getRootURL() })
                })
                .catch(e => {
                    console.error(e);
                });
            },
            sendLoggedInEvent() {
                bus.$emit('loggedIn', '');
            }
        }
    }
</script>


<style lang="scss" scoped>
@import "../styles/components/login.scss"
</style>